/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：68
 */

"use strict"

var r
var o
var i
var a
export { r as a }
export { o as c }
export { i as d }
export { a as b };
(function (e) {
  e.H5 = "H5"
  e.Community = "COMMUNITY"
  e.Editor = "EDITOR"
  e.Cordova = "CORDOVA"
})(r || (r = {}));
(function (e) {
  e[e.ImageLibrary = 0] = "ImageLibrary"
  e[e.IconLibrary = 1] = "IconLibrary"
  e[e.SoundLibrary = 2] = "SoundLibrary"
  e[e.ResourceLibrary = 3] = "ResourceLibrary"
})(o || (o = {}));
(function (e) {
  e[e.IMAGE = 0] = "IMAGE"
  e[e.ICON = 1] = "ICON"
  e[e.SOUND = 2] = "SOUND"
})(i || (i = {}));
(function (e) {
  e.DEVICE_VIBRATE = "DEVICE_VIBRATE"
  e.DEVICE_NOT_VIBRATE = "DEVICE_NOT_VIBRATE"
  e.PLAYER_DATA_WATCH = "PLAYER_DATA_WATCH"
  e.RUNTIME_LOG = "RUNTIME_LOG"
  e.EMULATOR = "EMULATOR"
  e.PLAYER_PERMISSION = "PLAYER_PERMISSION"
})(a || (a = {}))
export default r
